import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import axios from "axios";
import toast from "react-hot-toast";
import { API_ENDPOINTS } from "../../constants/config";

export default function AttendanceByDay() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [attendance, setAttendance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [shiftLookup, setShiftLookup] = useState({});
  const [stopLookup, setStopLookup] = useState({});

  const vehicle = JSON.parse(localStorage.getItem("vehicle"));
  const vehicleId = vehicle?.id || vehicle?._id;
  const routeId = vehicle?.route?._id || vehicle?.route; // fallback if available

  // Fetch vehicle route and build lookup tables
  useEffect(() => {
    const fetchRoute = async () => {
      if (!routeId) {
        return;
      }
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(API_ENDPOINTS.vehicleRoute(routeId), {
          headers: { Authorization: `Bearer ${token}` },
        });
        const route = res.data?.data?.vehicleRoute || res.data?.vehicleRoute;
        if (route && route.shifts) {
          const shiftMap = {};
          const stopMap = {};
          route.shifts.forEach((shift) => {
            shiftMap[shift._id.toString()] = shift.name;
            if (shift.stops) {
              shift.stops.forEach((stop) => {
                stopMap[stop._id.toString()] = stop.name;
              });
            }
          });
          setShiftLookup(shiftMap);
          setStopLookup(stopMap);
        } else {
        }
      } catch (err) {
      }
    };
    fetchRoute();
  }, [routeId]);

  useEffect(() => {
    // Fetch attendance for current date on mount
    fetchAttendance(selectedDate);
  }, []);

  const fetchAttendance = async (date) => {
    setLoading(true);
    setError("");
    setAttendance(null);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(API_ENDPOINTS.attendanceBusStopHistory, {
        params: {
          vehicle: vehicleId,
          date: date.toISOString().slice(0, 10),
        },
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true, // if your backend requires cookies/auth
      });
      setAttendance(res.data?.data?.attendance || null);
      if (!res.data?.data?.attendance) {
        toast("No attendance found for this day.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch attendance.");
      toast.error(err.response?.data?.message || "Failed to fetch attendance.");
    } finally {
      setLoading(false);
    }
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    fetchAttendance(date);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Attendance by Day</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col md:flex-row gap-6">
          <div>
            <input
              type="date"
              className="mt-2 px-4 py-2 border rounded"
              value={selectedDate.toISOString().slice(0, 10)}
              onChange={e => {
                const date = new Date(e.target.value);
                setSelectedDate(date);
                fetchAttendance(date);
              }}
            />
            {/* Removed Test Date Select (Today) button */}
          </div>
          <div className="flex-1">
            {loading && <div className="text-gray-500">Loading...</div>}
            {error && <div className="text-red-600">{error}</div>}
            {attendance && Array.isArray(attendance) && attendance.length > 0 ? (
              attendance.map((record) => {
                // Always use string IDs for lookup
                const shiftId = (record.shift?._id || record.shift || "").toString();
                const stopId = (record.stop?._id || record.stop || "").toString();
                const shiftName = Object.keys(shiftLookup).length > 0 ? (shiftLookup[shiftId] || "-") : "-";
                const stopName = Object.keys(stopLookup).length > 0 ? (stopLookup[stopId] || "-") : "-";
                if (shiftName === "-" || stopName === "-") {
                }
                return (
                  <div key={record._id} className="mb-4 p-2 border rounded">
                    <div className="mb-2 font-semibold">Type: {record.type ? record.type.charAt(0).toUpperCase() + record.type.slice(1) : "-"}</div>
                    <div className="mb-2">Shift: {shiftName}</div>
                    <div className="mb-2">Stop: {stopName}</div>
                    <div className="mb-2">Students:</div>
                    <ul className="list-disc ml-6">
                      {record.students && record.students.length > 0 ? (
                        record.students.map((s) => (
                          <li key={s.student?._id || s.student}>
                            {s.student?.name || s.student?.firstName || s.student} - {s.present ? "Present" : "Absent"}
                          </li>
                        ))
                      ) : (
                        <li>No students found.</li>
                      )}
                    </ul>
                  </div>
                );
              })
            ) : (
              <div>No attendance found for this day.</div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
} 